import React, { useState } from "react";
import star from "../../../assets/section_new_images/exploremore/star.png";
import enrol from "../../../assets/section_new_images/exploremore/enroll.png";
import start from "../../../assets/section_new_images/exploremore/start.png";
import ContactUsModal from "../ContactUsModal";

const HeaderEnrollNow = ({
  headerText,
  subtitle,
  rating,
  totalRating,
  enroll,
  started,
}) => {
  const [closeModal, setCloseModal] = useState(false);

  const toggleModal = () => {
    setCloseModal(!closeModal);
  };
  return (
    <div className="d-flex flex-column align-items-start headerEnrollNow_container">
      <h1 className="headerText mb-0 pr-md-5">{headerText}</h1>
      <p
        style={{
          color: "#7D7D7D",
          font: "500 clamp(1rem, 1.5vw, 1.2rem)/normal Nunito",
        }}
      >
        {subtitle}
      </p>
      <div>
        <div className="d-flex flex-row align-items-center headerEnrollNow_rating">
          <img src={star} alt="star" />
          <p className="mb-0">{rating}</p>
          <span>{totalRating}</span>
        </div>
        <div className="d-flex flex-row align-items-center headerEnrollNow_rating py-2">
          <img src={enrol} alt="enroll" />
          <span>{enroll}</span>
        </div>
        <div className="d-flex flex-row align-items-center headerEnrollNow_rating">
          <img src={start} alt="start" />
          <span>{started}</span>
        </div>
        <button onClick={toggleModal}>Enroll Now</button>
        {closeModal && (
          <ContactUsModal closeModal={closeModal} toggleModal={toggleModal} />
        )}
      </div>
    </div>
  );
};

export default HeaderEnrollNow;
